module.exports = {
  "country": "CY",
  "artist": "Andrew Lambrou",
  "song": "Beat a broken Heart",
  "year": "2023",
  "place": "12",
  "spotify": "5dRAJ9UsR0qyMMKnonWewz"
};